import React from 'react';

import debounce from 'lodash/debounce';

import { TextInput } from 'components/input/TextInput/TextInput';
import { TextareaInput } from 'components/input/TextareaInput/TextareaInput';
import type { SanitizedField } from 'models/field';

const WAIT_TIME = 250;

type TextInputFieldProps = {
  field: SanitizedField<string>;
  handleBlur?: (name: string) => void;
  handleChange: (name: string, value: string) => void;
};

const TextInputField = ({
  field,
  handleBlur,
  handleChange,
}: TextInputFieldProps) => {
  const {
    autoComplete = 'off',
    defaultValue,
    error,
    format,
    hint,
    id,
    label,
    readOnly,
    required,
  } = field;

  if (format === 'text') {
    return (
      <TextareaInput
        autoComplete={autoComplete}
        error={error}
        hint={hint}
        label={label as string}
        name={id}
        onBlur={name => setTimeout(() => handleBlur?.(name), WAIT_TIME)}
        onChange={debounce(handleChange, WAIT_TIME)}
        readOnly={readOnly}
        value={defaultValue as string}
        required={required}
      />
    );
  }

  return (
    <TextInput
      error={error}
      hint={hint}
      label={label as string}
      name={id}
      onBlur={name => setTimeout(() => handleBlur?.(name), WAIT_TIME)}
      onChange={debounce(handleChange, WAIT_TIME)}
      readOnly={readOnly}
      value={defaultValue as string}
      required={required}
    />
  );
};

export { TextInputField };
